export default function () {
    return {
        refs: {
            filterBlock: document.querySelector('#layered-filter-block'),
            filterAction: document.querySelector('#showFilters')
        },

        init() {
            this.refs.filterBlock.classList.add('filter-no-options');
            this.refs.filterAction.classList.add('hidden');
        }
    };
}
